import { Typography } from "@material-ui/core";
import * as React from "react";
import { withRouter, Link } from 'react-router-dom';
const valueUserLoginType = localStorage.getItem('userLoginType') || '';

export default function Footer(props) {

  return (
    <div style={{ padding: '0px' }}>
      <div className="flight-footer">
        <a href="https://grospick.com/about" style={{ textDecoration: 'none' }}
        >
          <Typography variant="span">About</Typography>
        </a>
        <a href="https://grospick.com/policy" style={{ textDecoration: 'none' }}
        >
          <Typography variant="span">Privacy</Typography>
        </a>
        <a href="https://grospick.com/termsConditions" style={{ textDecoration: 'none' }}
        >
          <Typography variant="span">Terms</Typography>
        </a>
        <a href="https://grospick.com/contact" style={{ textDecoration: 'none' }}
        >
          <Typography variant="span">Contact</Typography>
        </a>
        {valueUserLoginType == "vendor" || valueUserLoginType == "admin" ? "" :
          <>       <Link
            to="/vendor/login"
            style={{ textDecoration: 'none' }}
          >
            <Typography variant="span"
            >
              Agent Login
            </Typography>
          </Link>
            <Link
              to="/admin/login"
              style={{ textDecoration: 'none' }}
            >
              <Typography variant="span"
              >
                Admin Login
              </Typography>
            </Link></>}
      </div>
    </div>
  );
}



